
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ed9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ed9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("88qjr", function(module, exports) {
module.exports = import("loYsm").then(()=>parcelRequire('8vkSn'));

});

parcelRegister("2rg6L", function(module, exports) {
module.exports = import("kWF1S").then(()=>parcelRequire('iuuQU'));

});

parcelRegister("9TrhC", function(module, exports) {
module.exports = import("lsTqB").then(()=>parcelRequire('kWP0U'));

});

class $5b407029490fcf5e$export$2e2bcd8739ae039 {
    constructor(){
        const themeToggle = document.querySelector('#theme-toggle');
        const storedTheme = localStorage.getItem('theme');
        // check the system theme
        const getSystemTheme = ()=>{
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        };
        // check if storedTheme exists, if not use the system theme
        const themeToApply = storedTheme ? storedTheme : getSystemTheme();
        // apply the theme
        document.documentElement.setAttribute('data-theme', themeToApply);
        // add click listeners to all theme buttons
        themeToggle.addEventListener('click', ()=>{
            const currentTheme = document.documentElement.getAttribute('data-theme');
            const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
            document.documentElement.setAttribute('data-theme', newTheme);
            localStorage.setItem('theme', newTheme);
        });
    }
}


const $78dfe73affbdf956$var$breakpoints = {
    mobile: '(min-width: 478px)',
    landscape: '(min-width: 768px)',
    tablet: '(min-width: 992px)',
    desktop: '(min-width: 1200px)',
    ultrawide: '(min-width: 2000px)'
};
class $78dfe73affbdf956$var$BreakpointManager {
    constructor(){
        this.mediaQueries = {};
        this.listeners = new Set();
        this.handleChange = this.handleChange.bind(this);
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
        Object.entries($78dfe73affbdf956$var$breakpoints).forEach(([name, query])=>{
            const mediaQuery = window.matchMedia(query);
            this.mediaQueries[name] = mediaQuery;
            if (typeof mediaQuery.addEventListener === 'function') {
                mediaQuery.addEventListener('change', this.handleChange);
                return;
            }
            if (typeof mediaQuery.addListener === 'function') mediaQuery.addListener(this.handleChange);
        });
    }
    getState() {
        return Object.fromEntries(Object.entries(this.mediaQueries).map(([name, mediaQuery])=>[
                name,
                mediaQuery.matches
            ]));
    }
    is(name) {
        return Boolean(this.mediaQueries[name]?.matches);
    }
    onChange(callback) {
        this.listeners.add(callback);
        callback(this.getState());
        return ()=>{
            this.listeners.delete(callback);
        };
    }
    handleChange() {
        const state = this.getState();
        this.listeners.forEach((listener)=>listener(state));
    }
}
const $78dfe73affbdf956$var$breakpoint = new $78dfe73affbdf956$var$BreakpointManager();
var $78dfe73affbdf956$export$2e2bcd8739ae039 = $78dfe73affbdf956$var$breakpoint;


class $8e70265d1f4a6d3a$export$2e2bcd8739ae039 {
    constructor(){
        this.nav = document.querySelector('.nav');
        this.navList = document.querySelector('.nav__list');
        this.navLinks = document.querySelectorAll('.nav__link');
        this.navLinkDefault = document.querySelector('.nav__link--default');
        this.navRect = document.querySelector('.nav__rect');
        this.homeButton = document.querySelector('#home-button');
        this.homeButtonRect = document.querySelector('.home__rect');
        this.themeButton = document.querySelector('#theme-toggle');
        this.themeButtonRect = document.querySelector('.theme__rect');
        this.navMenu = document.querySelector('.nav__menu');
        this.isHomeLanding = Boolean(this.homeButton && this.homeButton.classList.contains('nav__link--default'));
        this.activeTarget = this.navLinkDefault;
        this.resizeObserver = null;
        this.bindEvents();
        (0, $78dfe73affbdf956$export$2e2bcd8739ae039).onChange(()=>this.init());
        this.init();
    }
    bindEvents() {
        if (!this.homeButton) return;
        this.navLinks.forEach((link)=>{
            link.addEventListener('pointerenter', ()=>this.setActiveTarget(link));
            link.addEventListener('pointerleave', ()=>{
                this.setActiveTarget(this.navLinkDefault);
                if (!this.isHomeLanding) this.homeButtonRect.classList.remove('home__rect--is-visible');
            });
        });
        this.homeButton.addEventListener('pointerenter', ()=>{
            this.setActiveTarget(this.homeButton);
            if (!this.isHomeLanding) this.homeButtonRect.classList.add('home__rect--is-visible');
        });
        this.homeButton.addEventListener('pointerleave', ()=>{
            this.setActiveTarget(this.navLinkDefault);
            if (!this.isHomeLanding) this.homeButtonRect.classList.remove('home__rect--is-visible');
        });
        if (this.themeButton && this.themeButtonRect) {
            this.themeButton.addEventListener('pointerenter', ()=>this.setActiveTarget(this.themeButton));
            this.themeButton.addEventListener('pointerleave', ()=>this.setActiveTarget(this.navLinkDefault));
        }
        if (this.navMenu) this.navMenu.addEventListener('click', ()=>{
            this.navMenu.classList.toggle('nav__menu--is-open');
        });
    }
    init() {
        if (!this.navRect || !this.navList || !this.navLinkDefault || !this.homeButtonRect || !this.homeButton) return;
        this.activeTarget = this.navLinkDefault;
        this.updateRects();
        this.navRect.classList.add('nav__rect--is-visible');
        this.homeButtonRect.classList.add('home__rect--is-visible');
        this.themeButtonRect?.classList.add('theme__rect--is-visible');
        this.observeLayout();
        if (!this.isHomeLanding) this.navLinkDefault.style.background = 'inherit';
        if (this.navMenu) {
            this.updateMobileMenuHeight();
            if ((0, $78dfe73affbdf956$export$2e2bcd8739ae039).is('landscape')) this.navMenu.classList.remove('nav__menu--is-open');
        }
    }
    setActiveTarget(target) {
        this.activeTarget = target;
        this.updateRects();
    }
    updateRects() {
        const target = this.activeTarget || this.navLinkDefault;
        this.setRectToElement(this.navRect, this.navList, target);
        this.setRectToElement(this.homeButtonRect, this.homeButton, target);
        if (this.themeButton && this.themeButtonRect) this.setRectToElement(this.themeButtonRect, this.themeButton, target);
    }
    setRectToElement(rect, reference, target) {
        const referenceBounds = reference.getBoundingClientRect();
        const targetBounds = target.getBoundingClientRect();
        const offsetX = targetBounds.left - referenceBounds.left - reference.clientLeft;
        rect.style.setProperty('--rect-width', `${targetBounds.width}px`);
        rect.style.setProperty('--rect-offset-x', `${offsetX}px`);
    }
    observeLayout() {
        if (typeof ResizeObserver === 'undefined') return;
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(()=>this.updateRects());
        this.resizeObserver.observe(this.navList);
        this.resizeObserver.observe(this.homeButton);
        if (this.themeButton) this.resizeObserver.observe(this.themeButton);
    }
    updateMobileMenuHeight() {
        const numItems = this.navMenu.querySelectorAll('.nav__item').length;
        const itemHeight = this.navMenu.querySelector('.nav__item')?.getBoundingClientRect().height || 0;
        this.navMenu.style.setProperty('--menu-height', `${itemHeight * numItems}px`);
    }
}


class $13c9de89553da81a$export$2e2bcd8739ae039 {
    constructor(){
        this.hoverFill = document.querySelectorAll('.hover-fill, .hover-link, .tooltip');
        this.hoverGlow = document.querySelectorAll('.hover-glow');
        this.ctaLinks = document.querySelectorAll('.past-research-card-link--cta');
        this.hoverFill.forEach((filler)=>{
            filler.addEventListener('mouseenter', function(e) {
                let parentOffset = filler.getBoundingClientRect();
                let relX = e.pageX - window.scrollX - parentOffset.left;
                let relY = e.pageY - window.scrollY - parentOffset.top;
                // Set CSS variables for positioning
                filler.style.setProperty('--hover-x', `${relX}px`);
                filler.style.setProperty('--hover-y', `${relY}px`);
            });
            filler.addEventListener('mouseout', function(e) {
                let parentOffset = filler.getBoundingClientRect();
                let relX = e.pageX - window.scrollX - parentOffset.left;
                let relY = e.pageY - window.scrollY - parentOffset.top;
                // Update `--hover-x` and `--hover-y` variables on mouse exit
                filler.style.setProperty('--hover-x', `${relX}px`);
                filler.style.setProperty('--hover-y', `${relY}px`);
            });
        });
        this.hoverGlow.forEach((glower)=>{
            glower.addEventListener('mousemove', function(e) {
                let parentOffset = glower.getBoundingClientRect();
                let relX = e.pageX - window.scrollX - parentOffset.left;
                let relY = e.pageY - window.scrollY - parentOffset.top;
                // Set CSS variables for positioning
                glower.style.setProperty('--hover-x', `${relX}px`);
                glower.style.setProperty('--hover-y', `${relY}px`);
            });
            glower.addEventListener('mouseout', function(e) {
                let parentOffset = glower.getBoundingClientRect();
                let relX = e.pageX - window.scrollX - parentOffset.left;
                let relY = e.pageY - window.scrollY - parentOffset.top;
                // Update `--hover-x` and `--hover-y` variables on mouse exit
                glower.style.setProperty('--hover-x', `${relX}px`);
                glower.style.setProperty('--hover-y', `${relY}px`);
            });
        });
        this.ctaLinks.forEach((cta)=>{
            const gradientClasses = [
                'is-grad-1',
                'is-grad-2',
                'is-grad-3',
                'is-grad-4'
            ];
            if (!gradientClasses.some((cls)=>cta.classList.contains(cls))) cta.classList.add('is-grad-1');
            const cycleGradient = ()=>{
                let currentIndex = 0;
                gradientClasses.forEach((cls, index)=>{
                    if (cta.classList.contains(cls)) currentIndex = index;
                });
                const nextIndex = (currentIndex + 1) % gradientClasses.length;
                gradientClasses.forEach((cls)=>cta.classList.remove(cls));
                cta.classList.add(gradientClasses[nextIndex]);
            };
            cta.addEventListener('mouseleave', cycleGradient);
            cta.addEventListener('blur', cycleGradient);
        });
    }
}


class $500cf8b511c56ced$export$2e2bcd8739ae039 {
    constructor(){
        const tooltipTerms = document.querySelectorAll('[data-tooltip]');
        tooltipTerms.forEach((term)=>{
            const tooltipText = term.getAttribute('data-tooltip');
            if (!tooltipText) return;
            const tooltipBox = document.createElement('div');
            tooltipBox.className = 'tooltip-box';
            tooltipBox.textContent = tooltipText;
            document.body.appendChild(tooltipBox);
            const updatePosition = ()=>{
                const rect = term.getBoundingClientRect();
                tooltipBox.style.left = `${rect.left + rect.width / 2}px`;
                tooltipBox.style.top = `${rect.top}px`;
            };
            term.addEventListener('mouseenter', ()=>{
                updatePosition();
                tooltipBox.classList.add('tooltip-box--visible');
            });
            term.addEventListener('mouseleave', ()=>{
                tooltipBox.classList.remove('tooltip-box--visible');
            });
            term.addEventListener('focus', ()=>{
                updatePosition();
                tooltipBox.classList.add('tooltip-box--visible');
            });
            term.addEventListener('blur', ()=>{
                tooltipBox.classList.remove('tooltip-box--visible');
            });
            window.addEventListener('scroll', updatePosition, {
                passive: true
            });
            window.addEventListener('resize', updatePosition);
        });
    }
}


class $f78c136ff8994872$export$2e2bcd8739ae039 {
    constructor(){
        this.stickyElements = document.querySelectorAll('.sticky');
        this.frame = null;
        this.update = this.update.bind(this);
        this.onScroll = this.onScroll.bind(this);
        document.addEventListener('scroll', this.onScroll, {
            passive: true
        });
        window.addEventListener('resize', this.onScroll, {
            passive: true
        });
        this.update();
    }
    onScroll() {
        if (this.frame === null) this.frame = requestAnimationFrame(this.update);
    }
    update() {
        this.frame = null;
        // Read all positions before changing styles to avoid interleaving layout reads and writes.
        const stuck = Array.from(this.stickyElements, (element)=>element.getBoundingClientRect().top < 0);
        this.stickyElements.forEach((element, index)=>{
            element.classList.toggle('sticky--is-stuck', stuck[index]);
        });
    }
    destroy() {
        if (this.frame !== null) cancelAnimationFrame(this.frame);
        document.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }
}


const $0cc82a8dffb8d633$var$prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
class $0cc82a8dffb8d633$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.speed = Number(element.dataset.parallaxSpeed || 0.12);
        this.hasFixedAncestor = this.findFixedAncestor();
        this.frame = null;
        this.lastScrollY = window.scrollY;
        this.onScroll = this.onScroll.bind(this);
        this.update = this.update.bind(this);
        if ($0cc82a8dffb8d633$var$prefersReducedMotion.matches) return;
        window.addEventListener('scroll', this.onScroll, {
            passive: true
        });
        window.addEventListener('resize', this.onScroll, {
            passive: true
        });
        this.update();
    }
    findFixedAncestor() {
        let ancestor = this.element.parentElement;
        while(ancestor !== null){
            if (getComputedStyle(ancestor).position === 'fixed') return true;
            ancestor = ancestor.parentElement;
        }
        return false;
    }
    onScroll() {
        this.lastScrollY = window.scrollY;
        if (this.frame === null) this.frame = window.requestAnimationFrame(this.update);
    }
    update() {
        this.frame = null;
        let offset;
        if (this.hasFixedAncestor) offset = -window.scrollY * this.speed;
        else {
            const bounds = this.element.getBoundingClientRect();
            const viewportCenter = window.innerHeight / 2;
            const elementCenter = bounds.top + bounds.height / 2;
            offset = (elementCenter - viewportCenter) * this.speed;
        }
        this.element.style.setProperty('--parallax-y', `${offset.toFixed(2)}px`);
    }
    destroy() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame !== null) window.cancelAnimationFrame(this.frame);
    }
}





const $54b47fc030b7b21e$var$components = [
    {
        class: (0, $5b407029490fcf5e$export$2e2bcd8739ae039),
        selector: '#theme-toggle'
    },
    {
        class: (0, $8e70265d1f4a6d3a$export$2e2bcd8739ae039),
        selector: 'nav'
    },
    {
        class: (0, $13c9de89553da81a$export$2e2bcd8739ae039),
        selector: 'html'
    },
    {
        load: ()=>(parcelRequire("88qjr")),
        selector: '.gallery',
        once: true
    },
    {
        load: ()=>(parcelRequire("2rg6L")),
        selector: '.synth'
    },
    {
        class: (0, $500cf8b511c56ced$export$2e2bcd8739ae039),
        selector: '.tooltip',
        once: true
    },
    {
        class: (0, $f78c136ff8994872$export$2e2bcd8739ae039),
        selector: '.sticky',
        once: true
    },
    {
        class: (0, $0cc82a8dffb8d633$export$2e2bcd8739ae039),
        selector: '.parallax'
    },
    {
        load: ()=>(parcelRequire("9TrhC")),
        selector: '.dynamic-background'
    }
];
document.addEventListener('DOMContentLoaded', ()=>{
    $54b47fc030b7b21e$var$components.forEach(async (component)=>{
        const elements = document.querySelectorAll(component.selector);
        if (!elements.length) return;
        try {
            const Component = component.class || (await component.load()).default;
            if (component.once) new Component(elements[0], component.options);
            else elements.forEach((element)=>new Component(element, component.options));
        } catch (error) {
            console.error(`Could not initialize ${component.selector}.`, error);
        }
    });
});


//# sourceMappingURL=alanjyu.com.4bd83acd.js.map
